module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_LockClosed_16"],"path":[{"$":{"d":"M12,7V5A3,3,0,0,0,9,2H7A3,3,0,0,0,4,5V7H2v7H14V7ZM6,5A1,1,0,0,1,7,4H9a1,1,0,0,1,1,1V7H6Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_LockClosed_16.svg
// module id = GCkH
// module chunks = 1